import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { fetchAddress } from '@fttb/common';
import { ERROR_TYPES } from "../../constants";
var controller = null;
export var getAddress = createAsyncThunk('getAddress', /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query, _ref) {
    var signal, rejectWithValue;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          signal = _ref.signal, rejectWithValue = _ref.rejectWithValue;
          _context.prev = 1;
          if (!((query === null || query === void 0 ? void 0 : query.length) < 2)) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", []);
        case 4:
          if (controller) {
            controller.abort();
            controller = null;
          }
          controller = new AbortController();
          signal.addEventListener('abort', function () {
            var _controller;
            (_controller = controller) === null || _controller === void 0 || _controller.abort();
          });
          _context.next = 9;
          return fetchAddress({
            signal: controller.signal,
            params: {
              query: query
            }
          });
        case 9:
          return _context.abrupt("return", _context.sent);
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](1);
          if (!axios.isCancel(_context.t0)) {
            _context.next = 16;
            break;
          }
          return _context.abrupt("return", rejectWithValue(ERROR_TYPES.cancel));
        case 16:
          throw new Error();
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 12]]);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());